<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h3 style="text-align: center">ใบกำกับภาษี</h3>
            <div class="row">
                <div class="col-sm-6">
                    <div class="row form-group">
                        <div class="col-sm-4" style="text-align: right">วันที่</div>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.date"
                                :format="changeFormat"
                                class="w-100"
                                :lang="lang"
                                placeholder="วันที่สร้าง">
                            </date-picker>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4" style="text-align: right">ผู้จำหน่าย</div>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.vendor"
                                :options="optionVendor"
                                track-by="vendor_id"
                                :customLabel="vendorVendor"
                                :show-labels="false"
                                placeholder="เลือกผู้จำหน่าย">
                            </multiselect>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4" style="text-align: right">วันที่ออกใบกำกับภาษีจากผู้จำหน่าย</div>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.date_from_vendor"
                                :format="changeFormat"
                                class="w-100"
                                :lang="lang"
                                placeholder="วันที่จ่ายเงิน">
                            </date-picker>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4" style="text-align: right">เลขที่ใบกำกับภาษีจากผู้จำหน่าย</div>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="form.tax_from_vendor"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4" style="text-align: right">เลขที่ใบเสร็จ</div>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="form.billing_number"/>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row form-group" v-if="form.id">
                        <div class="col-sm-4" style="text-align: right">เลขที่ใบกำกับภาษี</div>
                        <div class="col-sm-6">
                            <input class="form-control" v-model="form.tax_number"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4" style="text-align: right">จำนวนเงิน</div>
                        <div class="col-sm-6">
                            <input class="form-control" disabled :value="total | currency"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4" style="text-align: right">เลขที่ PO</div>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.po"
                                :options="optionPO"
                                :multiple="true"
                                track-by="id"
                                label="po_number"
                                :show-labels="false"
                                @input="getMaterialFromPurchaseOrder"
                                placeholder="เลือก PO">
                            </multiselect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 text-right">VAT 7%</div>
                        <div class="col-6">
                            <b-form-group>
                                <b-form-radio-group
                                    id="radio-slots"
                                    v-model="form.is_vat"
                                    :options="options_vat"
                                    name="radio-options-slots"
                                >
                                </b-form-radio-group>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="table-responsive" style="min-height: 200px">
                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <th width="100px">ลำดับ</th>
                            <th>รายการ</th>
                            <th width="150px">จำนวน</th>
                            <th width="150px">ราคา</th>
                            <th width="150px">ราคารวม</th>
                            <th width="150px">เพิ่ม / ลบ</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(detail,index) in details">
                            <td>
                                {{ ++index }}
                            </td>
                            <td>
                                <template v-if="form.po.length > 0"> <!--รายการ Po-->
                                    <multiselect
                                        v-model="detail.material"
                                        :options="materials_list"
                                        track-by="id"
                                        label="name"
                                        :show-labels="false"
                                        placeholder="เลือกรายการวัตถุดิบ">
                                    </multiselect>
                                    <div style="display: none;">
                                        {{ detail.material ? detail.material_id = detail.material.id : "" }}
                                    </div>
                                </template>
                                <template v-else>
                                    <multiselect
                                        v-model="detail.account"
                                        :options="optionAccountList"
                                        track-by="id"
                                        :customLabel="accountLabel"
                                        :show-labels="false"
                                        placeholder="เลือกรหัสบัญชีสำหรับภาษีซื้อ">
                                    </multiselect>
                                    <div style="display: none;">
                                        {{ detail.account ? detail.account_id = detail.account.id : "" }}
                                    </div>
                                </template>
                            </td>
                            <td>
                                <input type="text" class="form-control" v-model="detail.quantity"/>
                            </td>
                            <td>
                                <input type="text" class="form-control" v-model="detail.price"/>
                            </td>
                            <td>
                                {{
                                    detail.total = detail.quantity ? detail.price ? form.is_vat ?
                                                parseFloat(detail.quantity) * parseFloat(detail.price)
                                                : parseFloat(detail.quantity) * parseFloat(detail.price)
                                            : 0
                                        : 0 | currency
                                }}
                            </td>
                            <td>
                                <!--เพิ่ม-->
                                <button type="button"
                                        @click="addDetails"
                                        v-if="details.length == index"
                                        class="btn btn-primary">
                                    <icon name="plus"></icon>
                                </button>
                                <!--ลบ-->
                                <button type="button"
                                        @click="removeDetails(index)"
                                        v-if="index < details.length"
                                        class="btn btn-danger">
                                    <icon name="trash"></icon>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row form-group">
                    <div class="col-10 text-right">อัตรา VAT 7%</div>
                    <div class="col-2">
                        <input class="form-control" :value="vat_rate | currency" disabled/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-10 text-right">ยอดรวมสุทธิ</div>
                    <div class="col-2 font-weight-bold">{{ parseFloat(total) | currency }} บาท</div>
                </div>
            </div>
            <div class="col text-center mt-3">
                <button type="button" class="btn btn-success" @click="saveTaxPayment">
                    <icon name="save"></icon>
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button type="button" class="btn btn-outline-secondary" @click="goToTaxPayoffList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
            <br>
        </div>
        <!--<pre class="alert-success">{{materials_list}}</pre>-->
        <!--<pre class="alert-primary">{{details}}</pre>-->
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    name: "tax-payment-form",
    components: {
        DatePicker,
        Multiselect
    },
    created() {
        this.$store.dispatch("Vendor/getVendorAll");
        this.$store.dispatch("PurchaseOrder/getPurchaseOrderNotCreateRR");
        this.getMaterialFromPurchaseOrder();
        this.$store.dispatch("TaxPayment/getAllTaxPaymentAccount").then(res => {
            this.optionAccountList = res;
        })
    },

    data() {
        return {
            options_vat: [
                {text: 'มี', value: 1},
                {text: 'ไม่มี', value: 0},
            ],
            materials_list: [],
            optionAccountList: [],
            items: [
                {
                    text: "รายการใชกำกับภาษีซื้อ",
                    to: {name: "tax-payment-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            optionVendor: state => {
                return state.Vendor.vendorAll;
            },
            form: state => {
                return state.TaxPayment.form
            },
            details: state => {
                return state.TaxPayment.form.tax_payment_details
            },
            optionPO: state => {
                return state.PurchaseOrder.purchase_not_rr
            }
        }),
        total() {
            this.form.total = this.details.reduce((carry, detail) => {
                return carry + detail.total
            }, 0);
            // this.form.total_before_vat = this.details.reduce((carry, detail) => {
            //     return carry + detail.before_vat
            // }, 0);
            if (this.form.is_vat && !this.form.from_cs) {
                this.form.total += this.form.total * 0.07
            } else if (this.form.is_vat && this.form.from_cs) {
                //console.log(this.form.total)
                // this.form.total = this.form.total_before_vat
            }
            return this.form.total
        },
        vat_rate() {
            let vat = 0;
            if (this.form.is_vat && !this.form.from_cs) {
                vat = this.total - this.total * 100 / 107;
            } else if (this.form.is_vat && this.form.from_cs) {
                vat = this.total * 0.07;
            }
            // if(this.form.is_vat){
            //     // vat = parseFloat(this.total) * 7/100;
            //     vat = this.total - this.total * 100 / 107;
            // }
            return vat
        }
    },
    methods: {
        accountLabel(option) {
            return `${option.code} - ${option.name}`
        },
        vendorVendor(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        addDetails() {
            this.$store.dispatch("TaxPayment/addTaxPaymentDetails");
        },
        removeDetails(index) {
            this.$store.dispatch("TaxPayment/removeTaxPaymentDetails", index - 1);
        },
        saveTaxPayment() {
            if (!this.form.vendor) {
                alert("กรุณาเลือกผู้จำหน่าย");
            } else {
                let vendor_id = "";
                if (this.form.vendor) {
                    vendor_id = this.form.vendor.id;
                }
                if (this.form.date) {
                    this.form.date = moment(this.form.date).format("YYYY-MM-DD");
                } else {
                    this.form.date = moment().format("YYYY-MM-DD");
                }
                let data = {
                    date: this.form.date,
                    vendor_id: vendor_id,
                    tax_number: this.form.tax_number,
                    po_id: this.form.po_id,
                    tax_from_vendor: this.form.tax_from_vendor,
                    date_from_vendor: this.form.date_from_vendor,
                    billing_number: this.form.billing_number,
                    // total : this.total,
                    is_vat: this.form.is_vat,
                    tax_payment_details: this.details,
                };
                if (!this.form.id) { // create
                    this.$store.dispatch("TaxPayment/createTaxPayment", data);
                } else {
                    this.$store.dispatch("TaxPayment/updateTaxPayment", {
                        id: this.form.id,
                        data: data
                    });
                }
                this.goToTaxPayoffList();
            }
        },
        goToTaxPayoffList() {
            this.$router.push("/accounting/tax-payment");
        },
        getMaterialFromPurchaseOrder() {
            let po_id = [];
            if (this.form.po.length > 0) {
                this.form.po.forEach(po => {
                    po_id.push(po.id);
                    po.details.forEach(detail => {
                        if (!this.materials_list.includes(detail.material)) {
                            this.materials_list.push(detail.material)
                        }
                    })
                })
            }
            this.form.po_id = po_id.toString();
        }
    }
}
</script>

<style scoped>

</style>
